/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './FooterLinkList.style';
import FooterLink from './FooterLink';

import type { Link } from './type/linkTypes';

type Props = {
  layoutClass?: string,
  links: Array<Link>,
};

const useStyles = createUseStyles(styles);

const FooterLinkList = ({ layoutClass, links }: Props): React.Node => {
  const classes: Object = useStyles();

  // Classes

  const rootClasses = classNames(classes.root, layoutClass);

  // Elements

  const itemElts = links.map((link, index) => (
    <li className={classes.item} key={index}>
      <FooterLink {...link} />
    </li>
  ));

  return <ul className={rootClasses}>{itemElts}</ul>;
};

export default FooterLinkList;
